import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.708,1.579c-.49-.262-1.081-.233-1.54.074l-4.647,3.099c-.418.279-.668.746-.668,1.248s.25.969.668,1.248l4.647,3.099c.251.167.541.252.832.252.242,0,.485-.059.708-.178.488-.261.792-.768.792-1.322V2.901c0-.554-.304-1.061-.792-1.322Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretLeftFill12.js.map